import { createStructuredSelector } from "reselect";
import {
    INFRA_DELIVERABLE_PROJECT,
    INFRA_DELIVERABLE_PROJECT_SUCCESS,
    INFRA_DELIVERABLE_PROJECT_ERROR,
    INFRA_DELIVERABLE_PHASES,
    INFRA_DELIVERABLE_PHASES_SUCCESS,
    INFRA_DELIVERABLE_PHASES_ERROR,
    INFRA_DELIVERABLE_PHASE_SET,
    INFRA_DELIVERABLE_LIST,
    INFRA_DELIVERABLE_LIST_SUCCESS,
    INFRA_DELIVERABLE_LIST_ERROR,
    INFRA_DELIVERABLE_FREQUENCY,
    INFRA_DELIVERABLE_FREQUENCY_SUCCESS,
    INFRA_DELIVERABLE_FREQUENCY_ERROR,
    INFRA_DELIVERABLE_ACTIVITY_TYPE,
    INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS,
    INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR,
    INFRA_DELIVERABLE_STATUS_REVIEW,
    INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS,
    INFRA_DELIVERABLE_STATUS_REVIEW_ERROR,
    INFRA_DELIVERABLE_USERS,
    INFRA_DELIVERABLE_USERS_SUCCESS,
    INFRA_DELIVERABLE_USERS_ERROR,
    INFRA_DELIVERABLE_EDIT_MODAL_SET,
    INFRA_DELIVERABLE_EDIT_CHANGE_SET,
    INFRA_DELIVERABLE_VIEW_MODAL_SET,
    INFRA_DELIVERABLE_VIEW_SET,
    INFRA_DELIVERABLE_ADD,
    INFRA_DELIVERABLE_ADD_SUCCESS,
    INFRA_DELIVERABLE_ADD_ERROR,
    INFRA_DELIVERABLE_UPDATE,
    INFRA_DELIVERABLE_UPDATE_SUCCESS,
    INFRA_DELIVERABLE_UPDATE_ERROR,
    INFRA_ACTIVITY_LIST,
    INFRA_ACTIVITY_LIST_SUCCESS,
    INFRA_ACTIVITY_LIST_ERROR,
    INFRA_ACTIVITY_ADD_MODAL_SET,
    INFRA_ACTIVITY_ADD_CHANGE_SET,
    INFRA_ACTIVITY_EDIT_MODAL_SET,
    INFRA_ACTIVITY_EDIT_CHANGE_SET,
    INFRA_ACTIVITY_VIEW_MODAL_SET,
    INFRA_ACTIVITY_VIEW_SET,
    INFRA_ACTIVITY_ADD,
    INFRA_ACTIVITY_ADD_SUCCESS,
    INFRA_ACTIVITY_ADD_ERROR,
    INFRA_ACTIVITY_UPDATE,
    INFRA_ACTIVITY_UPDATE_SUCCESS,
    INFRA_ACTIVITY_UPDATE_ERROR,
    INFRA_ACTIVITY_CANCEL,
    INFRA_ACTIVITY_CANCEL_SUCCESS,
    INFRA_ACTIVITY_CANCEL_ERROR,
    INFRA_ACTIVITY_DOCS_MODAL_SET,
    INFRA_ACTIVITY_DOC_DELETE,
    INFRA_ACTIVITY_DOC_DELETE_SUCCESS,
    INFRA_ACTIVITY_DOC_DELETE_ERROR,
} from "../../actions";

export const NAME = 'infrastructureDeliverable';

export const InfrastructureDeliverableSelector = createStructuredSelector({
    infrastructureDeliverable: (state) => state.infrastructureDeliverable,
});

export const InfrastructureDeliverableProject = (data) => ({ type: INFRA_DELIVERABLE_PROJECT, payload: data });
export const InfrastructureDeliverableProjectSuccess = (data) => ({ type: INFRA_DELIVERABLE_PROJECT_SUCCESS, payload: data });
export const InfrastructureDeliverableProjectError = (error) => ({ type: INFRA_DELIVERABLE_PROJECT_ERROR, payload: error });

export const InfrastructureDeliverablePhases = (data) => ({ type: INFRA_DELIVERABLE_PHASES, payload: data });
export const InfrastructureDeliverablePhasesSuccess = (data) => ({ type: INFRA_DELIVERABLE_PHASES_SUCCESS, payload: data });
export const InfrastructureDeliverablePhasesError = (error) => ({ type: INFRA_DELIVERABLE_PHASES_ERROR, payload: error });

export const InfrastructureDeliverablePhaseSet = (data) => ({ type: INFRA_DELIVERABLE_PHASE_SET, payload: data });

export const InfrastructureDeliverableList = (id_deliverable_phase, id_project_infrastructure_info) => ({ type: INFRA_DELIVERABLE_LIST, payload: { id_deliverable_phase, id_project_infrastructure_info } });
export const InfrastructureDeliverableListSuccess = (data) => ({ type: INFRA_DELIVERABLE_LIST_SUCCESS, payload: data });
export const InfrastructureDeliverableListError = (error) => ({ type: INFRA_DELIVERABLE_LIST_ERROR, payload: error });

export const InfrastructureDeliverableFrequency = (data) => ({ type: INFRA_DELIVERABLE_FREQUENCY, payload: data });
export const InfrastructureDeliverableFrequencySuccess = (data) => ({ type: INFRA_DELIVERABLE_FREQUENCY_SUCCESS, payload: data });
export const InfrastructureDeliverableFrequencyError = (error) => ({ type: INFRA_DELIVERABLE_FREQUENCY_ERROR, payload: error });

export const InfrastructureDeliverableActivityType = (data) => ({ type: INFRA_DELIVERABLE_ACTIVITY_TYPE, payload: data });
export const InfrastructureDeliverableActivityTypeSuccess = (data) => ({ type: INFRA_DELIVERABLE_ACTIVITY_TYPE_SUCCESS, payload: data });
export const InfrastructureDeliverableActivityTypeError = (error) => ({ type: INFRA_DELIVERABLE_ACTIVITY_TYPE_ERROR, payload: error });

export const InfrastructureDeliverableStatusReview = (data) => ({ type: INFRA_DELIVERABLE_STATUS_REVIEW, payload: data });
export const InfrastructureDeliverableStatusReviewSuccess = (data) => ({ type: INFRA_DELIVERABLE_STATUS_REVIEW_SUCCESS, payload: data });
export const InfrastructureDeliverableStatusReviewError = (error) => ({ type: INFRA_DELIVERABLE_STATUS_REVIEW_ERROR, payload: error });

export const InfrastructureDeliverableUsers = (data) => ({ type: INFRA_DELIVERABLE_USERS, payload: data });
export const InfrastructureDeliverableUsersSuccess = (data) => ({ type: INFRA_DELIVERABLE_USERS_SUCCESS, payload: data });
export const InfrastructureDeliverableUsersError = (error) => ({ type: INFRA_DELIVERABLE_USERS_ERROR, payload: error });

/* Entregable: Editar (crea si no hay id_deliverable, actualiza si existe) */
export const InfrastructureDeliverableEditModalSet = (data) => ({ type: INFRA_DELIVERABLE_EDIT_MODAL_SET, payload: data });
export const InfrastructureDeliverableEditChangeSet = (data) => ({ type: INFRA_DELIVERABLE_EDIT_CHANGE_SET, payload: data });

/* Entregable: Visualizar (solo lectura) */
export const InfrastructureDeliverableViewModalSet = (data) => ({ type: INFRA_DELIVERABLE_VIEW_MODAL_SET, payload: data });
export const InfrastructureDeliverableViewSet = (data) => ({ type: INFRA_DELIVERABLE_VIEW_SET, payload: data });

export const InfrastructureDeliverableAdd = (data, phase) => ({ type: INFRA_DELIVERABLE_ADD, payload: { data, phase } });
export const InfrastructureDeliverableAddSuccess = (data) => ({ type: INFRA_DELIVERABLE_ADD_SUCCESS, payload: data });
export const InfrastructureDeliverableAddError = (error) => ({ type: INFRA_DELIVERABLE_ADD_ERROR, payload: error });

export const InfrastructureDeliverableUpdate = (data, phase) => ({ type: INFRA_DELIVERABLE_UPDATE, payload: { data, phase } });
export const InfrastructureDeliverableUpdateSuccess = (data) => ({ type: INFRA_DELIVERABLE_UPDATE_SUCCESS, payload: data });
export const InfrastructureDeliverableUpdateError = (error) => ({ type: INFRA_DELIVERABLE_UPDATE_ERROR, payload: error });

/* Activities */
export const InfrastructureActivityList = (id_deliverable) => ({ type: INFRA_ACTIVITY_LIST, payload: { id_deliverable } });
export const InfrastructureActivityListSuccess = (data) => ({ type: INFRA_ACTIVITY_LIST_SUCCESS, payload: data });
export const InfrastructureActivityListError = (error) => ({ type: INFRA_ACTIVITY_LIST_ERROR, payload: error });

/* Actividad: Agregar */
export const InfrastructureActivityAddModalSet = (data) => ({ type: INFRA_ACTIVITY_ADD_MODAL_SET, payload: data });
export const InfrastructureActivityAddChangeSet = (data) => ({ type: INFRA_ACTIVITY_ADD_CHANGE_SET, payload: data });

/* Actividad: Editar */
export const InfrastructureActivityEditModalSet = (data) => ({ type: INFRA_ACTIVITY_EDIT_MODAL_SET, payload: data });
export const InfrastructureActivityEditChangeSet = (data) => ({ type: INFRA_ACTIVITY_EDIT_CHANGE_SET, payload: data });

/* Actividad: Visualizar (solo lectura) */
export const InfrastructureActivityViewModalSet = (data) => ({ type: INFRA_ACTIVITY_VIEW_MODAL_SET, payload: data });
export const InfrastructureActivityViewSet = (data) => ({ type: INFRA_ACTIVITY_VIEW_SET, payload: data });

export const InfrastructureActivityAdd = (data, id_deliverable) => ({ type: INFRA_ACTIVITY_ADD, payload: { data, id_deliverable } });
export const InfrastructureActivityAddSuccess = (data) => ({ type: INFRA_ACTIVITY_ADD_SUCCESS, payload: data });
export const InfrastructureActivityAddError = (error) => ({ type: INFRA_ACTIVITY_ADD_ERROR, payload: error });

export const InfrastructureActivityUpdate = (data, id_deliverable) => ({ type: INFRA_ACTIVITY_UPDATE, payload: { data, id_deliverable } });
export const InfrastructureActivityUpdateSuccess = (data) => ({ type: INFRA_ACTIVITY_UPDATE_SUCCESS, payload: data });
export const InfrastructureActivityUpdateError = (error) => ({ type: INFRA_ACTIVITY_UPDATE_ERROR, payload: error });

export const InfrastructureActivityCancel = (id_activity, id_deliverable) => ({ type: INFRA_ACTIVITY_CANCEL, payload: { id_activity, id_deliverable } });
export const InfrastructureActivityCancelSuccess = (data) => ({ type: INFRA_ACTIVITY_CANCEL_SUCCESS, payload: data });
export const InfrastructureActivityCancelError = (error) => ({ type: INFRA_ACTIVITY_CANCEL_ERROR, payload: error });

export const InfrastructureActivityDocsModalSet = (data) => ({ type: INFRA_ACTIVITY_DOCS_MODAL_SET, payload: data });

export const InfrastructureActivityDocDelete = (id_activity_document, id_deliverable) => ({ type: INFRA_ACTIVITY_DOC_DELETE, payload: { id_activity_document, id_deliverable } });
export const InfrastructureActivityDocDeleteSuccess = (data) => ({ type: INFRA_ACTIVITY_DOC_DELETE_SUCCESS, payload: data });
export const InfrastructureActivityDocDeleteError = (error) => ({ type: INFRA_ACTIVITY_DOC_DELETE_ERROR, payload: error });
